import { gql } from "@apollo/client";

export const CREATE_INDICACION = gql`
    mutation CreateIndicacion($input: AddIndicacionEvaluacionInput!)
    {
        createIndicacionEvaluacion(input: $input) 
        {
            idEvaluacionIndicacion
            idEvaluacion
            idInsumo
        }
    }
`;